import {RouteContext} from "../../RouteContext";
import { Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";
import Post from "./Post";
import Edit from "./Edit";
import MainkeywordRouter from "./mainKeyword/MainkeywordRouter";
import PathJointRouter from "./pathJoint/PathJointRouter";
import PathBrowserRouter from "./browser/PathBrowserRouter";
import PathJointReportReasonRouter from "./pathJointReportReason/PathJointReportReasonRouter";
import PathJointReportRouter from "./pathJointReport/PathJointReportRouter";
import PathRouter from "./path/PathRouter";
import ParticipationRouter from "./participation/ParticipationRouter";
import PathJointEventRouter from "./event/PathJointEventRouter";
import FunnelRouter from "./funnel/FunnelRouter";
import Pulym from "./Pulym";
import Nsrt from "./Nsrt";
import PathJointFileRouter from "./pathJointFile/PathJointFileRouter";
import ShoppingParticipationPolicyRouter from "./policy/ShoppingParticipationPolicyRouter";
import ExcelExportRouter from "./excelExport/ExcelExportRouter";


export default function ShoppingRouter(props: RouteContext) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:id'} element={<Detail {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/pulym'} element={<Pulym {...props} />} />
            <Route path={'/nsrt'} element={<Nsrt {...props} />} />
            <Route path={'/edit/:id'} element={<Edit {...props} />} />
            <Route
                path={'/mainKeywords/*'}
                element={<MainkeywordRouter {...props} />} />
            <Route
                path={'/pathJoints/*'}
                element={<PathJointRouter {...props} />} />
            <Route
                path={'/pathBrowsers/*'}
                element={<PathBrowserRouter {...props} />} />
            <Route
                path={'/paths/*'}
                element={<PathRouter {...props} />} />
            <Route
                path={'/participations/*'}
                element={<ParticipationRouter {...props} />} />
            <Route
                path={'/pathJointEvents/*'}
                element={<PathJointEventRouter {...props} />} />
            <Route
                path={'/funnels/*'}
                element={<FunnelRouter {...props} />} />
            <Route
                path={'/pathJointReportReasons/*'}
                element={<PathJointReportReasonRouter {...props} />} />
            <Route
                path={'/pathJointReports/*'}
                element={<PathJointReportRouter {...props} />} />
            <Route
                path={'/policies/*'}
                element={<ShoppingParticipationPolicyRouter {...props} />} />
            <Route
                path={'/pathJointFiles/*'}
                element={<PathJointFileRouter {...props} />} />
            <Route
                path={'/excelExport/*'}
                element={<ExcelExportRouter {...props} />} />
        </Routes>
    </>
}